module.exports = __webpack_public_path__ + "static/media/S3P5_additional-recommendations.6a641c34.mp3";